import { render, staticRenderFns } from "./EditorBox.vue?vue&type=template&id=8d43c3ec&scoped=true&"
import script from "./EditorBox.vue?vue&type=script&lang=js&"
export * from "./EditorBox.vue?vue&type=script&lang=js&"
import style0 from "./EditorBox.vue?vue&type=style&index=0&id=8d43c3ec&prod&lang=scss&"
import style1 from "./EditorBox.vue?vue&type=style&index=1&id=8d43c3ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d43c3ec",
  null
  
)

export default component.exports